/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../../../../Fixes';
import Builder from '../../../../../../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "model": {
                    "nested": {
                      "settings": {
                        "nested": {
                          "rst": {
                            "nested": {
                              "common": {
                                "nested": {
                                  "FloorPlan": {
                                    "fields": {
                                      "showFloorPlanTimers": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional",
                                        "options": {
                                          "default": false
                                        }
                                      },
                                      "useTableInactivityIndicators": {
                                        "type": "bool",
                                        "id": 2,
                                        "rule": "optional",
                                        "options": {
                                          "default": false
                                        }
                                      },
                                      "tableIndicatorWarningTime": {
                                        "type": "uint32",
                                        "id": 3,
                                        "rule": "optional"
                                      },
                                      "tableIndicatorAlertTime": {
                                        "type": "uint32",
                                        "id": 4,
                                        "rule": "optional"
                                      },
                                      "canShowFloorPlanEmptyState": {
                                        "type": "bool",
                                        "id": 5,
                                        "rule": "optional",
                                        "options": {
                                          "default": false
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.rst?.nested?.common?.nested?.FloorPlan) {
  $root.addJSON(jsonData);
}

/**
 * IMPORTANT: When Adding New Fields to Device Profiles, you MUST implement their default values at:
 *
 * /java/device-settings/src/main/java/com/squareup/devicesettings/processing/profiles/v2/defaults
 *
 * ⚠️ WARNING: Fields will not be automatically hydrated unless default values are implemented in the Java code above.
 * This is a mandatory step for all device profile settings.
 *
 * SOURCE FloorPlan @ squareup/devicesettings/profiles/v2/model/settings/rst/common/floor_plan.proto at 17:1
 */
export const FloorPlan = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.rst.common.FloorPlan');
fixType(FloorPlan);
Builder.createAndAttachToType(FloorPlan);